module.exports = __webpack_public_path__ + "static/img/1-1.8ad01e4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/eng/1-1.png
// module id = SDjb
// module chunks = 0